<template src="./justifyModal.pug" lang="pug"></template>

<script>
import vSelect from 'vue-select'
import { Money } from 'v-money'
import Modal from '../../../modals/modal/Modal'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import { maskThousand } from '../../../../utils/numberMasker.js'

export default {
  name: 'JustifyModal',

  components: {
    vSelect,
    Money,
    Modal,
    ButtonPrimary
  },

  data () {
    return {
      disableButton: false,
      isLoadingData: true,
      selectedOccurrenceReason: false,
      occurrenceReasons: [],
      commentary: null,
      valueJustify: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      divergenceValue: '',
      notJustifiedValue: '',
      isTotal: false
    }
  },

  computed: {
    arrayJustify () {
      return this.$store.getters.arrayJustify
    },

    itsAbleToJustify () {
      return this.selectedOccurrenceReason && !this.disableButton
    },

    allotmentId () {
      return this.$store.getters.idAllotment
    },

    totalAmountForInternalEntries () {
      return this.$store.getters.totalAmountForInternalEntries
    },

    totalAmountForBankEntries () {
      return this.$store.getters.totalAmountForBankEntries
    },

    totalDivergence () {
      return (this.totalAmountForBankEntries - this.totalAmountForInternalEntries) - this.totalAmountToJustify
    },

    totalAmountToJustify () {
      return this.calculateTotalToJustify()
    },

    finMovAdded () {
      return this.$store.getters.finMovAdded
    },

    bankStatAdded () {
      return this.$store.getters.bankStatAdded
    },

    arrayConciliationPlan () {
      return this.$store.getters.arrayConciliationPlan
    },

    totalDivergenceTransformed () {
      return maskThousand(Number(this.totalDivergence).toFixed(2))
    },

    totalNotJustified () {
      let value = this.valueJustify - this.totalDivergence
      return maskThousand(value)
    },

    divergentInstance () {
      return Number(this.totalDivergence).toFixed(2) !== '0.00'
    },

    hasPendingFinMov () {
      return this.$store.getters.hasPendingFinMov
    },

    hasPendingBankStat () {
      return this.$store.getters.hasPendingBankStat
    }
  },

  watch: {
    totalNotJustified () {
      this.setStyleValue()
    },

    isTotal () {
      if (this.isTotal) {
        this.valueJustify = this.totalDivergence
      }
    },

    arrayJustify () {
      this.valueJustify = 0.00
    },

    totalDivergence () {
      if (this.finMovAdded.length === 0 || this.bankStatAdded.length === 0) {
        this.valueJustify = this.totalDivergence
      } else {
        this.isTotal = false
        this.valueJustify = 0.00
      }
    }
  },

  methods: {
    calculateTotalToJustify () {
      let value = 0.00
      this.arrayJustify.forEach(justify => {
        value += justify.valor
      })
      return value
    },

    setStyleValue () {
      if (this.totalNotJustified === '0,00' || this.totalNotJustified === 0.00) {
        document.getElementById('labelTotalNotJustified').style.color = 'green'
      } else {
        document.getElementById('labelTotalNotJustified').style.color = 'red'
      }
    },

    getValueClass (value) {
      return value !== 0 ? 'divergence-value-modal' : 'conciliated-value-modal'
    },

    confirmJustifyAllotment () {
      let data = {
        id: this.arrayJustify.length + 1,
        valor: this.valueJustify,
        idMotivoOcorrencia: this.selectedOccurrenceReason ? this.selectedOccurrenceReason.id : null,
        motivoOcorrencia: this.selectedOccurrenceReason && this.selectedOccurrenceReason.label ? this.selectedOccurrenceReason.label : null,
        comentario: this.commentary
      }
      this.$store.dispatch('setJustify', data)
        .then(() => {
          this.closeModal()
        }).catch(() => {
          this.closeModal()
          this.$root.$refs.notification.global('E', 'ERRO')
        })
    },

    closeModal () {
      $('#justifyModal').modal('hide')
      this.selectedOccurrenceReason = null
      this.commentary = null
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },

    loadOccurrenceReasons () {
      let url = '/manualConciliation/occurrenceReasons/list'
      this.$store.dispatch('getOccurrenceReasons', url).then((response) => {
        this.occurrenceReasons = response.data.data
        this.isLoadingData = false
        this.occurrenceReasons.forEach(occurrenceReason => {
          occurrenceReason.label = occurrenceReason.codigo + ' - ' + occurrenceReason.descricao
        })
        this.occurrenceReasons.sort((a, b) => {
          return a.codigo - b.codigo
        })
      })
    },

    generateArrayWithIds (list) {
      let result = []
      list.forEach(item => {
        result.push(item.idMovimentacao ? item.idMovimentacao
          : item.idMovBank ? item.idMovBank : item.id)
      })
      return result
    }
  },

  created () {
    this.loadOccurrenceReasons()
  }
}
</script>

<style>
.centered-radio {
  margin: 0;
  height: 20px;
}

.centered-radio label {
  margin: 0;
  margin-right: -10px;
  margin-top: 2px;
}

.divergence-value-modal {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  color: red;
}

.conciliated-value-modal {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  color: green;
}

i.icon-margin-left {
  margin-left: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// JustifyModal.vue?7217da79